import request from '@/services/interceptor.js'

export const get_macchine = (filtri) => {
    return request({
        url: '/macchina',
        method: 'get',
        params: filtri || {},
        loadingBar: true
    })
}

export const get_macchina = (id) => {
    return request({
        url: `/macchina/${id}`,
        method: 'get',
        loadingBar: true
    })
}

export const get_macchina_kpi = () => {
    return request({
        url: '/macchina/kpi',
        method: 'get',
        loadingBar: true
    })
}

export const get_macchina_by_qr = (publicCode) => {
    return request({
        url: `/macchina/qr/${publicCode}`,
        method: 'get',
        loadingBar: true
    })
}

export const create_macchina = (par) => {
    return request({
        url: '/macchina',
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const update_macchina = (id, par) => {
    return request({
        url: `/macchina/${id}`,
        method: 'put',
        data: par,
        loadingBar: true
    })
}

export const duplica_macchina = (id) => {
    return request({
        url: `/macchina/${id}/duplica`,
        method: 'post',
        loadingBar: true
    })
}

export const delete_macchina = (id, conferma) => {
    return request({
        url: `/macchina/${id}`,
        method: 'delete',
        params: { conferma: !!conferma },
        loadingBar: true
    })
}